import React, { useEffect, useState } from "react";
import apiClient from "../axios/axiosInterceptor";

function AddPermissions({ loggedInUser, role, onClose, onSubmit }) {
    const [permissions, setPermissions] = useState([]);
    const [newPermissions, setNewPermissions] = useState(new Set());

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await apiClient.get(`/permissions`);
                setPermissions(response.data.list);
            } catch (error) {
                console.error('Error fetching permissions:', error);
            }
        };

        const fetchRolePermissions = async () => {
            try {
                const response = await apiClient.get(`/tenants/${loggedInUser.TenantId}/roles/${role.id}/permissions`);
                const rolePermissions = new Set(response.data.list.map(permission => permission.id));
                setNewPermissions(rolePermissions);
            } catch (error) {
                console.error('Error fetching role permissions:', error);
            }
        };

        fetchPermissions();
        fetchRolePermissions();
    }, []);

    const handleCheckboxChange = (permissionId) => {
        setNewPermissions(prev => {
            const newSelectedPermissions = new Set(prev);
            if (newSelectedPermissions.has(permissionId)) {
                newSelectedPermissions.delete(permissionId);
            } else {
                newSelectedPermissions.add(permissionId);
            }
            return newSelectedPermissions;
        });
    };

    const handleSubmit = () => {
        onSubmit(Array.from(newPermissions));
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <span className="close" onClick={onClose}>&times;</span>
                <h2>Add Permissions to {role.name}</h2>
                <table className="app-table">
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Assigned</th>
                    </tr>
                    </thead>
                    <tbody>
                    {permissions.map(permission => (
                        <tr key={permission.id}>
                            <td>{permission.id}</td>
                            <td>{permission.name}</td>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={newPermissions.has(permission.id)}
                                    onChange={() => handleCheckboxChange(permission.id)}
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <button onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
}

export default AddPermissions;
